import * as React from "react";
import { forwardRef } from "react";
const SvgLogoDigitSeven = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "800px", height: "800px", viewBox: "40 5 45 110", "aria-hidden": "true", role: "img", preserveAspectRatio: "xMidYMid meet", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M90.16 33.44L60.5 100.77c-.33.75-1.07 1.23-1.88 1.23h-8.76c-1.5 0-2.49-1.55-1.87-2.92l27.64-59.99c.63-1.36-.37-2.92-1.87-2.92H39.72c-1.14 0-2.06-.92-2.06-2.06v-6.07c0-1.14.92-2.06 2.06-2.06h48.56c1.14 0 2.06.92 2.06 2.06v4.56c-.01.3-.07.58-.18.84z" }));
const ForwardRef = forwardRef(SvgLogoDigitSeven);
export { ForwardRef as ReactComponent };
